import { render, staticRenderFns } from "./CollectionDetailTabLocation.vue?vue&type=template&id=3c8f00d4&"
import script from "./CollectionDetailTabLocation.vue?vue&type=script&lang=ts&"
export * from "./CollectionDetailTabLocation.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionDetailTabLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
